import type { OnChanges, SimpleChanges } from '@angular/core'
import { Component, input } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'

export interface ArticleManual {
  title: string
  categoryTitle: string
  description: string
  baseUrl: string
  pageNumber: number
  preface: string
}

@Component({
  standalone: true,
  selector: 'dhp-manual-dialog',
  templateUrl: './manual-dialog.html',
  imports: [TranslatePipe],
})
export class ManualDialog implements OnChanges {
  public readonly manual = input.required<ArticleManual | null>()

  protected isDialogOpenState = false
  protected manualUrl = ''

  public ngOnChanges(changes: SimpleChanges): void {
    const manual = this.manual()
    if (changes['manual'] && manual?.baseUrl && manual.pageNumber) {
      this.isDialogOpenState = true
      this.manualUrl = manual.baseUrl + '#page=' + manual.pageNumber
    } else {
      this.isDialogOpenState = false
      this.manualUrl = ''
    }
  }

  protected closeDialog(): void {
    this.isDialogOpenState = false
  }
}
